import React from 'react'
import { Grid } from "@mui/material"
import SectionDivider from "Pages/Admin/Users/CreateDrawer/Content/SectionDivider"
import SelectorWithSkeleton from "Pages/Admin/Users/CreateDrawer/Content/SelectorSkeleton"
import UserSitesField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/Sites"
import UserOfficesField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/Offices"
import UserNewOfficeSubSection from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice"


export default function UserSitesOfficesContent({ isLoading }) {


	return <Grid container spacing={2}>
		<Grid item>
			<SectionDivider title="Sites & Offices" icon="city"/>
		</Grid>
		<Grid item xs={12}/>
		<SelectorWithSkeleton SelectorComponent={UserSitesField} isLoading={isLoading} xs={6}/>
		<SelectorWithSkeleton SelectorComponent={UserOfficesField} isLoading={isLoading} xs={6}/>
		<Grid item xs={11}>
			<UserNewOfficeSubSection/>
		</Grid>
	</Grid>
}